module.exports = __webpack_public_path__ + "img/taxi-logo.62bdd169.png";